export default {
	title: 'scripts',
	components: [{ title: 'scripts', component: 'scripts_gen_2', min_ver: '2.6.0' }],
};
